import { AppState } from "../rootReducer";
import { getStepFeedbacks, getStepSelected } from "../userCampaign/selectors";
import { createSelector } from "reselect";

export const getFeedbackIdSelected = (state: AppState) =>
  state.historical.feedbackSelected || {};

export const getFeedbackSelected = createSelector(
  getFeedbackIdSelected,
  getStepFeedbacks,
  (feedbackSelected, feedbacks) => {
    const feedback = feedbacks.find(
      feedback => feedback._id === feedbackSelected,
    );

    return (
      feedback || {
        _id: "",
        createdAt: "",
        review: {},
        status: "new",
        rating: 0,
      }
    );
  },
);
